import { PayloadAction } from '@reduxjs/toolkit';

import { State } from '../types/state';

const setUserGeoPosition = (state: State, action: PayloadAction<State['geoPosition']['geoCords']>) => {
  state.geoPosition.geoCords = action.payload;
};

export default setUserGeoPosition;
